import { render } from "./NavbarSMRmaster.vue?vue&type=template&id=0a898954&scoped=true"
import script from "./NavbarSMRmaster.vue?vue&type=script&lang=js"
export * from "./NavbarSMRmaster.vue?vue&type=script&lang=js"

import "./NavbarSMRmaster.vue?vue&type=style&index=0&id=0a898954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a898954"]])

export default __exports__